<template>
  <div>
    <b-row
      v-for="(items, key) in displayData"
      :key="key"
      style="padding-left: 15px; box-sizing: border-box; margin-bottom: 15px"
    >
      <b-col style="padding-left: 0" cols="6">
        <b-card
          :img-src="items[0].itemImage"
          img-alt="Image"
          img-top
          tag="article"
          class="item-card"
          body-class="p5"
          @click="onItemTappedWith(items[0].itemCode)"
        >
          <b-card-text style="font-size: 14px; text-align: left; font-weight: bold">
            {{ items[0].name }}
          </b-card-text>
        </b-card>
      </b-col>
      <b-col cols="6" style="padding-left: 0px">
        <b-card
          v-if="items[1]"
          :img-src="items[1].itemImage"
          img-alt="Image"
          img-top
          tag="article"
          class="item-card"
          body-class="p5"
          @click="onItemTappedWith(items[1].itemCode)"
        >
          <b-card-text style="font-size: 14px; text-align: left; font-weight: bold">
            {{ items[1].name }}
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  props: {
    items: Array,
  },
  data() {
    return {
      displayData: [],
    }
  },
  watch: {
    items(items) {
      const rowPerIteimCount = 2 // 一行あたりの商品数
      this.displayData = [...Array(Math.ceil(items.length / rowPerIteimCount))].map((_, num) => {
        return items.slice(num * rowPerIteimCount, num * rowPerIteimCount + rowPerIteimCount)
      })
    },
  },
  methods: {
    onItemTappedWith(itemCode) {
      if (this.$route.path.startsWith('/order')) {
        this.$emit('onItemTappedWith', itemCode)
      } else {
        this.$router.push(`/order/${itemCode}`)
      }
    },
  },
}
</script>
